export default __webpack_public_path__ + "static/riens-e7d2768518b422b2923c060593f78434.png";